import moment from 'moment'

import 'moment/locale/id'
import 'moment/locale/vi'

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
